<template>
  <Block class="pwa" v-if="!isInstall.value">
    <div class="pwa-center">
      <p class="pwa-tip">{{ letter.pwaPayTip }}</p>
      <BlockClickable
        class="pwa-install"
        tagName="a"
        @click="isSafari ? showSafariTip() : installPwa()"
        ><span class="pwa-install-text"
          ><i class="bookmark-icon"></i>{{ letter.pwsInstall }}</span
        ></BlockClickable
      >
    </div>
  </Block>
</template>

<script>
import Vue from 'vue';
import { commonEmitUpload } from '../plugins/AnalyzePoint/index';
import { isSafari } from '../utiles/device';
import globalConfig from '@utiles/officialStore/globalConfig';
export default {
  name: 'PwaInstall',
  data() {
    return {
      isInstall: null,
      isSafari: isSafari()
    };
  },
  computed: {
    letter() {
      return this.$store.state.letter;
    }
  },
  created() {
    // 生成响应式对象，同步window的isInstall和组件data里面的isInstall，随意更改组件或是window的isInstall都会同步到另一个上
    const pwaState = Vue.observable(window.isInstall);
    this.isInstall = pwaState;
    window.isInstall = pwaState;
    // dev
    // this.isInstall.value = false;
    // console.log(this.isSafari);
  },
  mounted() {
    // app安装了
    window.addEventListener('appinstalled', () => {
      this.setIsInstall();
      // 回收 deferredPrompt 变量
      window.deferredPrompt = null;
      // pwa成功安装
      // console.log('pwa success install');
      commonEmitUpload('success-install-pwa', {
        event: 'success-install-pwa',
        newPage: false,
        type: 'change'
      });
    });
  },
  methods: {
    setIsInstall() {
      this.isInstall.value = true;
    },
    showSafariTip() {
      // console.log('展示提示');
    },
    updateUrlWithParams(currentUrl, newParams) {
      // 解析当前 URL
      const url = new URL(currentUrl);
      // 遍历并更新/添加新的查询参数
      Object.keys(newParams || {}).forEach(key => {
        url.searchParams.set(key, newParams[key]);
      });
      // 返回更新后的 URL 字符串
      return url.toString();
    },
    installPwa() {
      // 用户点击页面上的安装按钮
      // console.log('click-install-pwa-btn');
      commonEmitUpload('click-install-pwa-btn', {
        event: 'click-install-pwa-btn',
        newPage: false,
        type: 'click'
      });
      if (!window.deferredPrompt) return;
      window.deferredPrompt.prompt();
      window.deferredPrompt.userChoice.then(result => {
        if (result.outcome == 'dismissed') {
          // console.log('Refuse install pwa');
          // 用户点击页面上的安装按钮
          commonEmitUpload('cancel-install-pwa', {
            event: 'cancel-install-pwa',
            newPage: false,
            type: 'click'
          });
        } else if (result.outcome == 'accepted') {
          window.setIsInstall();
          this.setIsInstall();
          window.deferredPrompt = null;
          // console.log('Accept install pwa');
          // 用户点击页面上的安装按钮
          commonEmitUpload('accept-install-pwa', {
            event: 'accept-install-pwa',
            newPage: false,
            type: 'click'
          });
          // 2025-01-08 同manifest动态生成的参数链接一致
          const curCid = globalConfig.getHrefParam('cid');
          const curScid = globalConfig.getHrefParam('scid');
          try {
            let link = this.updateUrlWithParams(window.location.href, {
              cid: curCid,
              scid: curScid,
              mode: 'pwa'
            });
            window.location.href = window.globalGetGotoLink({ link });
          } catch (e) {
            console.error(e);
          }
        }
        // 接受了安装才会返回平台，没有接受不会返回平台
        // console.log('Install platform: ' + result.platform);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.pwa {
  z-index: 10;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  background-color: #f3f3f3;

  &-center {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc(50vw + 13.2vh);
    max-width: 100%;
    min-height: 56px;
    margin: auto;
    padding: 0 3vh;
    text-align: left;
  }

  &-tip {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0;
    font-size: 24px;
    font-weight: bold;
  }
  &-install {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    align-self: stretch;
    box-sizing: border-box;
    min-width: 240px;
    max-width: 50%;
    padding: 0 12px;
    background-color: #88dbad;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    color: #ffffff;
    cursor: pointer;

    &-text {
      vertical-align: middle;
    }

    .bookmark-icon {
      flex-shrink: 0;
      display: inline-block;
      width: 34px;
      height: 34px;
      background: url('../assets/image/icons/bookmark-icon.png') no-repeat
        center/contain;
      vertical-align: middle;
    }
  }
}

@media screen and (orientation: portrait) {
  .pwa {
    &-center {
      box-sizing: border-box;
      padding-left: 2vh;
      padding-right: 0;
      width: 100%;
    }

    &-tip {
      font-size: 28px;
    }
    &-install {
      min-width: 100px;
      padding: 0 18px;
      margin-left: 8px;
      font-size: 28px;
    }
  }
}

.is-blancozone {
  .pwa {
    background-color: #ffffff;
    &-tip {
      color: #5898db;
    }
    &-install {
      background-color: #bcd5ee;
      border-radius: 10px;
    }
  }
}
</style>
